import { render, staticRenderFns } from "./listC2cGroup.vue?vue&type=template&id=f33e58cc&"
import script from "./listC2cGroup.vue?vue&type=script&lang=js&"
export * from "./listC2cGroup.vue?vue&type=script&lang=js&"
import style0 from "./listC2cGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports